import React from 'react';
import { Card } from '../../../components/Card/Card';
import { Icon } from '../../../components/Icon/Icon';
import { t } from '../../../locales/translate';
import { useTask } from '../../../model/data';
import { runVenueLayoutExport } from '../../../model/exports';
import { VenueLayout } from '../../../model/venue';

interface Props {
  venueLayout: VenueLayout;
}

export function VenueLayoutCard({ venueLayout }: Props): JSX.Element {
  const exportTask = useTask({ handleError: true });

  return (
    <div className="venue-layout-card__wrapper" key={venueLayout.id}>
      <Card
        className="venue-layout-card"
        actions={
          venueLayout.importStatus === null || venueLayout.importStatus === 'done' ? (
            <>
              <Icon
                name="download--sm"
                tooltip={t.actions.downloadAsJSON}
                loading={exportTask.loading}
                onClick={() => exportTask.run(runVenueLayoutExport({ venueLayoutId: venueLayout.id }))}
              />
              <Icon
                name="printer"
                tooltip={`${t.actions.download} ${t.general.details}`}
                onClick={() => {
                  window.open(venueLayout.detailPdfDownloadUrl, 'noopener', 'noreferrer');
                }}
              />
            </>
          ) : (
            venueLayout.importStatus &&
            t.model.venueLayout.importStatus[venueLayout.importStatus] && (
              <span className="button button--small venue-layout-card__action">
                {t.model.venueLayout.importStatus[venueLayout.importStatus]}
              </span>
            )
          )
        }
      >
        <div className="venue-layout-card__text">{venueLayout.name}</div>
        <div className="venue-layout-card__text venue-layout-card__capacity">
          {venueLayout.capacity || t.general.notAvailable}
        </div>
        {venueLayout.archived && (
          <div className="venue-layout-card__text">
            <Icon name="eye-off" />
          </div>
        )}
      </Card>
    </div>
  );
}
